import { ReactElement } from 'react'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import { IconButton, Tooltip } from '@mui/material'

interface Props {
  reason: string
}

const DisabledChatButton = ({ reason }: Props): ReactElement => (
  <Tooltip title={reason}>
    {/* A disabled button fires no events, so the tooltip needs a wrapper. */}
    <span>
      <IconButton
        size="small"
        disabled
        aria-label="KI-Chat"
        sx={{ width: 32, height: 32 }}
        data-cy="ai-chat-button"
      >
        <ForumOutlinedIcon fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>
)

export default DisabledChatButton
